/**
 * Whether `host` is `apex` itself or a subdomain of it, e.g. `staging.tablerun.com` matches
 * `tablerun.com` but `nottablerun.com` and `tablerun.com.example.org` do not.
 *
 * Normalizes case and strips a port before comparing, so it is safe to call directly with a raw
 * `Host` header rather than only with an already-normalized hostname. `apex` is expected to
 * already be lowercase and portless.
 */
export const matchesApex = (host: string, apex: string): boolean => {
  const [normalizedHost] = host.toLowerCase().split(':');
  return normalizedHost === apex || normalizedHost.endsWith(`.${apex}`);
};
